<mat-card>
	<div
		class="list-loading-shade list-loading-shade-detail-card"
		*ngIf="isLoading"
	>
		<mat-progress-bar
			mode="indeterminate"
			class="mat-card-loading"
		></mat-progress-bar>
	</div>
	<rpshared-card-title
		*ngIf="icon && title"
		[icon]="icon"
		[title]="title"
	></rpshared-card-title>
	<mat-card-content>
		<ng-content></ng-content>
	</mat-card-content>
</mat-card>
